import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IAddress) {
    (function(Source) {
        Source["ADMIN"] = "ADMIN";
        Source["USER"] = "USER";
        Source["GOOGLE_PLACES"] = "GOOGLE_PLACES";
        Source["YELP"] = "YELP";
        Source["FOURQUARE"] = "FOURQUARE";
        Source["SHOPIFY_STORE_LOCATOR"] = "SHOPIFY_STORE_LOCATOR";
    })(IAddress.Source || (IAddress.Source = {}));
    (function(UspsType) {
        UspsType["RESIDENTIAL"] = "RESIDENTIAL";
        UspsType["COMMERCIAL"] = "COMMERCIAL";
        UspsType["MIXED"] = "MIXED";
    })(IAddress.UspsType || (IAddress.UspsType = {}));
    IAddress.build = function(partial) {
        return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
    };
})(IAddress || (IAddress = {}));
export var IAddress;
